import { status } from '@/alas';
import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
    props: ['farm', 'picture'],
    setup(props) {
        // ================
        //
        // refs
        //
        let config = ref(status.fetch('config'));
        let confirm = ref(null);
        // ================
        //
        // methods
        //
        let remove = (revenue) => {
            confirm.value.open(close => {
                props.picture.revenues.remove(revenue.id);
                close();
            });
        };
        let addAccount = () => {
            props.picture.revenues.write({
                name: '',
                value: null
            }, {
                insert: 0
            });
        };
        return {
            config,
            confirm,
            remove,
            addAccount
        };
    }
});
